import type { BlocklistEntry } from '@bartizo/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { formatRelative } from '../lib/time.js';
import { Facts } from '../ui/DataTable.js';
import { CauseList } from './BlocklistCauses.js';
import { ServerLinks } from './ServerLinks.js';

/** Under a blocklist row: the evidence, the timeline and where else to look. */
export function BlocklistRowDetail({ entry }: { entry: BlocklistEntry }): ReactNode {
  return (
    <div className="detail-grid">
      <section>
        <h4>What blocked it</h4>
        <CauseList entry={entry} />
        {entry.source === 'auto' && <p className="text-sm muted">{entry.reason}</p>}
        {entry.refused !== null && <p className="text-sm muted">Not enforced: {entry.refused}</p>}
        {entry.status === 'removed' && (
          <p className="text-sm muted">
            Removed by {entry.removedByEmail ?? 'a person'}:{' '}
            {entry.removedReason ?? 'no reason given'}
          </p>
        )}
      </section>
      <section>
        <h4>Timeline</h4>
        <Facts
          items={[
            ['Banned', `${String(entry.bans)} time${entry.bans === 1 ? '' : 's'}`],
            [
              'On servers',
              entry.serverRefs.length === 0 ? (
                String(entry.servers)
              ) : (
                <ServerLinks servers={entry.serverRefs} count={entry.servers} />
              ),
            ],
            ['First seen', formatRelative(entry.firstSeen)],
            ['Last seen', formatRelative(entry.lastSeen)],
            ['Ladder step', String(entry.level)],
            [
              'Servers that skip it',
              entry.excludedServers === 0 ? 'None' : String(entry.excludedServers),
            ],
          ]}
        />
      </section>
      <section>
        <h4>Go to</h4>
        <span className="link-list">
          <Link to={`/addresses/${encodeURIComponent(entry.ip)}`}>Open the address</Link>
        </span>
      </section>
    </div>
  );
}
